<div class="popup">
  <h2>{{title}}</h2>
  <p [innerHTML]="message"></p>
  <button class="shadow btn ds-btn-confirmation" (click)="closePopup()">Fermer</button>
</div>
